var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls"
  }, [_c('button', {
    on: {
      "click": _vm.togglePlay
    }
  }, [_c('i', {
    staticClass: "fa play-pause",
    class: {
      'fa-circle-o-notch': !_vm.soundcloud.ready, 'fa-play': !_vm.soundcloud.playing, 'fa-pause': _vm.soundcloud.playing
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dcbf8c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListenPage/PlayerControls.vue
// module id = q98E
// module chunks = 1